import * as React from 'react';
import { SVGProps } from 'react';
export const LeftArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={12}
    viewBox="0 0 14 12"
    fill="none"
    {...props}
  >
    <path
      fill="#C0C3D3"
      d="M13.25 6a.75.75 0 0 1-.75.75H3.314l3.22 3.22a.751.751 0 0 1-1.062 1.062l-4.5-4.5a.75.75 0 0 1 0-1.063l4.5-4.5a.751.751 0 0 1 1.062 1.063L3.313 5.25h9.188a.75.75 0 0 1 .75.75Z"
    />
  </svg>
);
